import { useEffect, useState } from "react";
import {
  type Theme,
  applyThemeToDocument,
  getThemeFromStorage,
} from "@/utils/theme-manager";

/**
 * Custom hook to manage the theme (light/dark) of the application.
 * It initializes the theme from localStorage or defaults to "light".
 *
 * @returns An object containing the current theme and a function to set the theme.
 */
export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() => getThemeFromStorage());

  useEffect(() => {
    applyThemeToDocument(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === "light"
        ? "dark"
        : prevTheme === "dark"
          ? "system"
          : "light",
    );
  };

  return {
    toggleTheme,
    theme,
  };
};
